import React, { useContext } from 'react'
import { RIGHTSHOLDER_CONTACT_VIEW_FORM } from '@Const/forms-constants'
import { formatPhoneNumber } from '@App/helpers/another-phone-formatter'
import { getCountryTitle } from '@App/helpers/get-country-title'
import { StoresContext } from '@App/contexts'
import { RightsholderContact } from '@Entities/rightsholder/rightsholder-contact'
import { isCountryUS } from '@App/common/utils'
import { getRightsholderContactType } from '@App/helpers/rightsholder-contact-type'

interface RightsholderContactFormViewProps {
    rightsholderContact: RightsholderContact
}

const RightsholderContactFormView = (props: RightsholderContactFormViewProps) => {
    const { libStore } = useContext(StoresContext)

    const calculateCountryTitle = (countryId: number): string =>
        isCountryUS(countryId) ? 'USA' : getCountryTitle(libStore.countries, countryId)

    const formatCountryPostalCodeLine = (countryId: number, postalCode?: string): string => {
        const countryTitle = calculateCountryTitle(countryId)
        if (countryTitle && postalCode) {
            return countryTitle + ', ' + postalCode
        }
        if (countryTitle) {
            return countryTitle
        }
        if (postalCode) {
            return postalCode
        }
        return ''
    }

    const { firstName, lastName, rightsholderContactTypeId, address, phoneNumber, email } = props.rightsholderContact

    return (
        <div className="body-contact-info">
            <section className="name-section">
                <div className="fields-row-container">
                    <div className="field-block">
                        <h5 className="title">{RIGHTSHOLDER_CONTACT_VIEW_FORM.contactName.label}</h5>
                        <p className="value">
                            {firstName} {lastName}
                        </p>
                    </div>
                    <div className="field-block">
                        <h5 className="title">{RIGHTSHOLDER_CONTACT_VIEW_FORM.contactType.label}</h5>
                        <p className="value">{getRightsholderContactType(rightsholderContactTypeId)}</p>
                    </div>
                </div>
            </section>
            <section className="mailing-address-section">
                <div className="fields-column-container custom">
                    <div className="field-block">
                        <h5 className="title">{RIGHTSHOLDER_CONTACT_VIEW_FORM.contactAddress.label}</h5>
                        {address && (
                            <>
                                <p className="value">{address.streetAddress ?? ''}</p>
                                {address.unitNumber && <p className="value">Unit #: {address.unitNumber}</p>}
                                {address.attention && <p className="value">Attention: {address.attention}</p>}
                                <p className="value">{[address.city, address.state].filter(Boolean).join(', ')}</p>
                                <p className="value">
                                    {formatCountryPostalCodeLine(Number(address.countryId), address.postalCode)}
                                </p>
                            </>
                        )}
                    </div>
                </div>
            </section>
            <section className="contact-info-section">
                <div className="fields-column-container">
                    <div className="field-block">
                        <h5 className="title">{RIGHTSHOLDER_CONTACT_VIEW_FORM.contactPhone.label}</h5>
                        <p className="value">{phoneNumber && formatPhoneNumber(phoneNumber)}</p>
                    </div>
                    <div className="field-block">
                        <h5 className="title">{RIGHTSHOLDER_CONTACT_VIEW_FORM.contactEmail.label}</h5>
                        <p className="value">{email ?? ''}</p>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default RightsholderContactFormView
